import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import CatalogProductCreateForm from "./-form";
import { CatalogCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/catalog-product/create")({
  component: CatalogProductCreatePage,
});

function CatalogProductCreatePage() {
  return (
    <div>
      <title>Create Catalog Product - Legrande Health Portal</title>
      <CatalogCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>New Catalog Product</CardTitle>
          <CardDescription>
            Enter catalog product details below.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <CatalogProductCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
